import { render } from "./ContactSettingsModal.vue?vue&type=template&id=5822b2cc&scoped=true"
import script from "./ContactSettingsModal.vue?vue&type=script&lang=js"
export * from "./ContactSettingsModal.vue?vue&type=script&lang=js"

import "./ContactSettingsModal.vue?vue&type=style&index=0&id=5822b2cc&scoped=true&lang=less"
import "./ContactSettingsModal.vue?vue&type=style&index=1&id=5822b2cc&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5822b2cc"]])

export default __exports__